/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import "../components/style.css";
import Axios from "axios";
import { FaCamera } from "react-icons/fa";
import Webcam from "react-webcam";
import jsQR from "jsqr";
// import { FaCheckCircle } from "react-icons/fa";
import Swal from "sweetalert2";
import No_image from "../img/No_Image.jpg";
import Spinner from "react-bootstrap/Spinner";
import ModalFormRisk_level from "../components/ModalFormRisk_level";
import {
  checkGroupsUser,
  getlocalStorage,
  formatdate,
  showLoading,
  hideLoading,
} from "../function/functionALL";

require("moment/locale/th");

const ModalSign = ({
  Id_TestRound,
  round_detail,
  round,
  Budget_year,
  DateTest,
  checkstatus,
}) => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    if (checkrefesh === 1) {
      navigate(0);
      setShow(false);
      setUserData("");
    }
    setShow(false);
    setUserData("");
  };
  const navigate = useNavigate();
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;

  const webcamRef = useRef(null);
  const [UserData, setUserData] = useState("");
  const [getQR, setgetQR] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [choiced, setChoice] = useState([]);
  const [chkEmpty, setChkEmpty] = useState(false);
  const [qrCode, setqrCode] = useState("");
  const openModal = () => {
    setIsModalOpen(true);
  };

  const [checkopencamera, setCheckOpenCamera] = useState(false);
  const imageSource = UserData?.tester_image
    ? process.env.REACT_APP_API_IMG + UserData?.tester_image
    : No_image;
  const [loading, setLoading] = useState(false);
  const [checkrefesh, setcheckrefesh] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (webcamRef.current && webcamRef.current.video.readyState === 4) {
        captureFrame();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const fetchQRData = async (code) => {
    try {
      setLoading(true);
      const af_id = code.data;
      const getQR = Id_TestRound + "-" + af_id;

      const response = await Axios.get(
        process.env.REACT_APP_API_TESTRESULT + `?q=${getQR}`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      );
      if (response.data.count === 0) {
        Swal.fire({
          icon: "error",
          title: "ไม่ได้อยู่ในวงรอบของหน่วยนี้",
        }).then((result) => {
          handleClose();
          setLoading(false);
        });
      } else {
        setUserData(response.data.results[0]);
        // console.log("response", response.data.results[0]);
        setLoading(false);
        setgetQR(getQR);
        setqrCode(code);
      }
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      }

      console.error("error", error);

      Swal.fire({
        icon: "error",
      });
    }
  };

  const captureFrame = () => {
    const video = webcamRef.current.video;
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);

    const code = jsQR(imageData.data, canvas.width, canvas.height);
    if (code) {
      fetchQRData(code);
      setCheckOpenCamera(false);
    }
  };

  const handlecamera = () => {
    setCheckOpenCamera(true);
  };


  const checkUser = (id, getQR) => {
    Axios.patch(
      process.env.REACT_APP_API_TESTRESULT + `${id}/`,
      {
        status: "1",
      },
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then(
        (res) => {
          navigate(`/PageTestRound`, {
            state: {
              props_RoundTest: round_detail,
            },
          });
        },
        Swal.fire({
          icon: "success",
          title: "ลงชื่อสำเร็จ!",
        }).then((result) => {
          // navigate(0);
          setShow(true);

          const fetchQRDataAgain = async () => {
            try {
              setLoading(true);
              const response = await Axios.get(
                process.env.REACT_APP_API_TESTRESULT + `?q=${getQR}`,
                {
                  headers: {
                    Authorization: "Token " + Token,
                  },
                }
              );

              setUserData(response.data.results[0]);
              setLoading(false);
              setgetQR(getQR);
              setcheckrefesh(1);
            } catch (error) {
              if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
                navigate("/notfound404");
              }
              console.error(error);
              Swal.fire({
                icon: "error",
              });
            }
          };

          fetchQRDataAgain();
          setCheckOpenCamera(false);
        })
      )
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        console.error(err);
        Swal.fire({
          icon: "error",
        });
      });
  };

  const handleSave = async (result, Tester) => {
    await Axios.patch(
      process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
      {
        body_data: result.body_data,
      },
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        // console.log("Success update: ", res.data.message);
        // console.log("Success: ", res);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("DataLogin");
          navigate(
            "/notfound404"
            // { state: {statusCode: err.response.status, txt: err.response.data} }
          );
        }
        console.error(err);
      });
    Axios.post(
      process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/add_answer/`,
      result.data,
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        const data = JSON.stringify(res);
        const result = JSON.parse(data);
        if (result.status === 200 || result.statusText === "OK") {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ!",
          }).then((result) => {
            setChoice([]);
            setIsModalOpen(false);
            fetchQRData(qrCode);
            setChkEmpty(true);
          });
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("id");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        console.error(err);
      });
  };

  return (
    <>
      {role_openRole?.FunctionaryTester ? (
        <button
          type="button"
          className="col-6 col-sm-5 col-md-6 col-lg-6 btn btn-primary mx-0 px-0"
          style={{ background: "rgb(2, 117, 216,0.80)", border: "none" }}
          onClick={handleShow}
        >
          <div className="mt-1" style={{ fontSize: "14px" }}>
            Scan QR <FaCamera />
          </div>
        </button>
      ) : (
        <button
          type="button"
          className="col-4 col-sm-5 col-md-6 col-lg-6 btn btn-primary mx-0 px-0"
          style={{ background: "rgb(2, 117, 216,0.80)", border: "none" }}
          onClick={handleShow}
        >
          <div className="mt-1" style={{ fontSize: "14px" }}>
            Scan QR <FaCamera />
          </div>
        </button>
      )}

      <Modal
        // show={showModalSign}
        // onHide={handleCloseModalSign}
        show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        keyboard={true}
      >
        <Modal.Body>
          <div className="rounded">
            <div>
              <div className="col-sm-12 col-xs-12 ">
                <div className="card-body rounded">
                  <div className="row d-flex mb-1">
                    <div
                      className="col-3 col-xs-12 card-title text-center fs-5 w-100 fs-3 "
                      style={{ color: "#000000" }}
                    >
                      <div
                        className="fw-bold mb-1"
                        style={{ fontSize: "22px" }}
                      >
                        ค้นหาด้วย QR Code{" "}
                      </div>
                      {loading ? (
                        ""
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{
                            background: "rgb(2, 117, 216,0.80)",
                            border: "none",
                          }}
                          onClick={handlecamera}
                        >
                          คลิกเปิดกล้องเพื่อแสกน <FaCamera />
                        </button>
                      )}
                    </div>
                    <hr></hr>
                  </div>
                  {/* <!-- No Labels Form --> */}
                  <form className="row ">
                    <div className="col-md-12 ">
                      <div className="text-center ">
                        {checkopencamera && (
                          <Webcam
                            className="rounded mb-1"
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            videoConstraints={{ facingMode: "environment" }}
                            style={{
                              width: "100%",
                              height: "auto",
                              border: "2px solid  #767676",
                            }}
                          />
                        )}

                        {!checkopencamera && UserData !== "" && (
                          <div>
                            <div className="text-center ">
                              <div className="mt-1 mb-3">
                                <img
                                  src={imageSource}
                                  alt="Profile"
                                  className="rounded img-fluid"
                                  style={{ maxHeight: "250px" }}
                                />
                              </div>
                              <table className="table table-hover rounded">
                                <thead
                                  style={{
                                    backgroundColor: "rgb(247, 247, 247, 0.5)",
                                  }}
                                >
                                  <tr>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        textAlign: "center",
                                        width: "30%",
                                        backgroundColor: "#666699",
                                        color: "white",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      ชื่อ - นามสกุล
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        backgroundColor: "#d0d9ff",
                                      }}
                                    >
                                      {UserData?.tester_fullname}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        textAlign: "center",
                                        backgroundColor: "#666699",
                                        color: "white",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      ตำแหน่ง
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        backgroundColor: "#d0d9ff",
                                      }}
                                    >
                                      {UserData?.tester_position}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        textAlign: "center",
                                        backgroundColor: "#666699",
                                        color: "white",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      การลงชื่อ
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        backgroundColor: "#d0d9ff",
                                      }}
                                    >
                                      {UserData?.status === 0 ? (
                                        <button
                                          type="button"
                                          className="btn btn-primary input-group-text ms-1"
                                          style={{
                                            fontSize: "14px",
                                            width: "115px",
                                            backgroundColor:
                                              "rgb(2, 117, 216,0.80)",
                                            border: "none",
                                          }}
                                          onClick={() =>
                                            checkUser(UserData?.id, getQR)
                                          }
                                        >
                                          คลิกเพื่อเช็คชื่อ
                                        </button>
                                      ) : (
                                        // <FaCheckCircle style={{ color: "#7cb342", fontSize: '18px' }} />
                                        <div
                                          style={{
                                            color: "RGB(124, 179, 66,0.80)",
                                            fontSize: "14px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          ลงชื่อเเล้ว
                                        </div>
                                      )}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        textAlign: "center",
                                        backgroundColor: "#666699",
                                        color: "white",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      การประเมินความเสี่ยง
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        backgroundColor: "#d0d9ff",
                                      }}
                                    >
                                      <Button
                                            type="button"
                                            className="btn btn-primary"
                                            style={{
                                              width: "115px",
                                              backgroundColor:
                                              UserData.risk_score === -1
                                                  ? "#FFB545"
                                                  : UserData.risk_score >= 1
                                                  ? "RGB(255, 0, 0,0.60)"
                                                  : UserData.risk_score === null
                                                  ? "#FFB545"
                                                  : "#7cb342",
                                              border: "none",
                                              // fontSize: "14px",
                                            }}
                                            onClick={() => openModal(UserData)}
                                          >
                                            {UserData.risk_score === -1
                                              ? "รอประเมิน"
                                              : UserData.risk_score >= 1
                                              ? " มีความเสี่ยง"
                                              : UserData.risk_score === null
                                              ? "รอประเมิน"
                                              : " ผ่าน"}
                                          </Button>
                                      {/* <ModalFormRisk_level
                                        Tester={UserData}
                                        round_detail={round_detail}
                                        Id_test={Id_TestRound}
                                        // Budget_year={Budget_year}
                                        round={round}
                                        // DateTest={DateTest}
                                        Risk_level={UserData?.risk_score}
                                        Tester_fullname=
                                        {UserData?.tester_fullname}

                                        Tester_position=
                                        {UserData?.tester_position}

                                        Tester_age={UserData?.tester_age}
                                        setModalSign={setShow}
                                        ShowModalSign={show}
                                      /> */}

                                      {/* {UserData?.risk_score === 0 ? (
                                        <div
                                          style={{
                                            color: "#7cb342",
                                            fontSize: "12px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          ผ่าน
                                        </div>
                                      ) : UserData?.risk_score === -1 ? (
                                        <div
                                          style={{
                                            color: "#0062f8",
                                            fontSize: "12px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                           รอประเมิน
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            color: "#FFB545",
                                            fontSize: "12px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                         มีความเสี่ยง
                                        </div>
                                      )} */}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        textAlign: "center",
                                        backgroundColor: "#666699",
                                        color: "white",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      การทดสอบ
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "12px",
                                        backgroundColor: "#d0d9ff",
                                      }}
                                    >
                                      {(UserData?.risk_score === -1 || UserData?.risk_score === null) ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-secondary ms-1"
                                            style={{
                                              textAlign: "center",
                                              width: "115px",
                                              fontSize: "12px",
                                              backgroundColor: "RGB(108, 117, 125,0.50)",
                                              border: "none",
                                              color: "white",
                                              cursor: "not-allowed",
                                              opacity: "0.6"

                                            }}
                                            disabled
                                          >
                                            กรุณาประเมินก่อน
                                          </button>
                                        </div>
                                      ) : (
                                        <Link
                                          to={`/PageTestScore`}
                                          state={{
                                            ID_user: UserData?.id,
                                            Id_test: Id_TestRound,
                                            round_detail: round_detail,
                                            Tester: UserData,
                                            // Budget_year: Budget_year,
                                            // Round: Round,
                                            // DateTest: DateTest,
                                            // Recorder_fullname: Recorder_fullname,
                                            // Num_register: Num_register,
                                            // Num_participant: Num_participant,
                                            // Num_test: Num_test,

                                            Work_unit_shortname:
                                              UserData?.work_unit_shortname,
                                            Tester_fullname:
                                              UserData?.tester_fullname,
                                            Tester_position:
                                              UserData?.tester_position,
                                            Tester_age: UserData?.tester_age,

                                            Blood_pressure_lower:
                                              UserData?.body_data
                                                .blood_pressure_lower,
                                            Blood_pressure_upper:
                                              UserData?.body_data
                                                .blood_pressure_upper,
                                            Bmi: UserData?.body_data.bmi,
                                            Height: UserData?.body_data.height,
                                            Weight: UserData?.body_data.weight,
                                            Risk_level: UserData?.risk_level,

                                            Pushup_quantity:
                                              UserData?.pushup.quantity,
                                            Pushup_recorder_fullname:
                                              UserData?.pushup.recorder_fullname,
                                            Pushup_recorder_id:
                                              UserData?.pushup.recorder_id,
                                            Pushup_score: UserData?.pushup.score,

                                            Run_quantity: UserData?.run.quantity,
                                            Run_recorder_fullname:
                                              UserData?.run.recorder_fullname,
                                            Run_recorder_id:
                                              UserData?.run.recorder_id,
                                            Run_score: UserData?.run.score,

                                            Situp_quantity:
                                              UserData?.situp.quantity,
                                            Situp_recorder_fullname:
                                              UserData?.situp.recorder_fullname,
                                            Situp_recorder_id:
                                              UserData?.situp.recorder_id,
                                            Situp_score: UserData?.situp.score,

                                            Walk_quantity:
                                              UserData?.walk.quantity,
                                            Walk_recorder_fullname:
                                              UserData?.walk.recorder_fullname,
                                            Walk_recorder_id:
                                              UserData?.walk.recorder_id,
                                            Walk_score: UserData?.walk.score,

                                            Total_score: UserData?.total_score,
                                            // NumberUser_status: numberUser.status
                                          }}
                                        >
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-primary ms-1"
                                              style={{
                                                textAlign: "center",
                                                width: "115px",
                                                fontSize: "16px",
                                                backgroundColor:
                                                  "rgb(2, 117, 216,0.80)",
                                                border: "none",
                                              }}
                                            >
                                              ผลคะแนน
                                            </button>
                                          </div>
                                        </Link>
                                      )}
                                    </th>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="col-md-12 col-12 gap-3 d-flex justify-content-center">
            {loading ? (
              <Button style={{ backgroundColor: "#FFB545", border: "none" }}>
                <Spinner
                  as="span"
                  animation="border"
                  variant="light"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                กรุณารอสักครู่...
              </Button>
            ) : (
              <Button variant="secondary" onClick={handleClose}>
                ปิด
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>

      <ModalFormRisk_level
        show={isModalOpen}
        setChoice={setChoice}
        choiced={choiced}
        setChkEmpty={setChkEmpty}
        chkEmpty={chkEmpty}
        onSave={handleSave}
        onClose={() => setIsModalOpen(false)}
        Tester={UserData}
        round_detail={round_detail}
        Budget_year={Budget_year}
        round={round}
        DateTest={DateTest}
        checkstatus={checkstatus}
      />
    </>
  );
};

export default ModalSign;
